export default {
  order: 16,
  name: "Resignation",
  icon: "exit_to_app",
  to: "/exit",
};
